// https://html.spec.whatwg.org/multipage/media.html#mediaerror
export const mediaErrors = {
  abortedError: {
    code: 1,
    message: 'MEDIA_ERR_ABORTED',
    isNetworkError: true,
  },
  networkError: {
    code: 2,
    message: 'MEDIA_ERR_NETWORK',
    isNetworkError: true,
  },
  decodeError: {
    code: 3,
    message: 'MEDIA_ERR_DECODE',
    isNetworkError: false,
  },
  formatError: {
    code: 4,
    message: 'MEDIA_ERR_SRC_NOT_SUPPORTED',
    isNetworkError: true,
  },
};

export const mediaErrorCodeMap = {
  [mediaErrors.abortedError.code]: mediaErrors.abortedError,
  [mediaErrors.networkError.code]: mediaErrors.networkError,
  [mediaErrors.decodeError.code]: mediaErrors.decodeError,
  [mediaErrors.formatError.code]: mediaErrors.formatError,
};

export const WEB_MEDIA_PLAYER_ICY_METADATA_ERROR =
  'webMediaPlayer.icyMetadata.error';

export const METADATA_ERROR_NAME = 'MetadataError';
